import { render } from "./Lovers.vue?vue&type=template&id=7dadf0e2&scoped=true&ts=true"
import script from "./Lovers.vue?vue&type=script&lang=ts"
export * from "./Lovers.vue?vue&type=script&lang=ts"

import "./Lovers.vue?vue&type=style&index=0&id=7dadf0e2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dadf0e2"]])

export default __exports__